<!-- Header - Sticky with glass effect -->
<header class="sticky top-0 z-30 bg-slate-900/80 backdrop-blur-lg border-b border-white/5">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16">

      <!-- Mobile menu button -->
      <button
        (click)="onMenuToggle()"
        class="lg:hidden p-2 -ml-2 text-slate-400 hover:text-white transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <!-- Logo -->
      <div (click)="scrollToTop()" class="cursor-pointer shrink-0 opacity-50 hover:opacity-100 transition-opacity duration-300">
        <naybrs-logo [width]="120"></naybrs-logo>
      </div>

      <!-- Desktop Navigation -->
      <nav class="hidden lg:flex items-center space-x-1">
        @for (item of navItems; track item.sectionId) {
          <button
            (click)="scrollToSection(item.sectionId)"
            class="px-4 py-2 text-sm font-medium text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-white/5">
            {{ item.name }}
          </button>
        }
      </nav>

      <!-- Product CTA -->
      <a
        href="https://naybrs.com"
        target="_blank"
        rel="noopener"
        class="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-300 shadow-lg shadow-primary-500/20 hover:shadow-primary-500/30">
        <span class="hidden sm:inline">Product</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
      </a>
    </div>
  </div>
</header>
